import { Header, Icon, Segment } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import Flex from "../../../../../components/Flex/Flex";
import Anchor from "../../../../ui/components/Anchor/Anchor";
import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";

export default function CreateProductionSegment({
	index,
	currentIndex,
	setCurrentIndex,
	header,
	subHeader,
	nextButtonDisabled,
	children,
	finalStep,
	showSkip,
	lastCheckMark,
}) {
	const { t } = useTranslation();

	return (
		<div style={{ position: "relative" }}>
			<Anchor active={index === currentIndex} />

			<Segment padded="very" disabled={index > currentIndex} raised={index === currentIndex}>
				<Flex flexDirection="column" alignItems="center" gap={20}>
					<Header as="h3" style={{ margin: 0 }} textAlign="center">
						<Header.Content>{header}</Header.Content>
						<Header.Subheader>{subHeader}</Header.Subheader>
					</Header>

					<div style={{ width: "100%", maxWidth: 500 }}>{children}</div>

					{currentIndex === index && !finalStep && (
						<PrimaryButton
							size="small"
							disabled={nextButtonDisabled}
							onClick={() => setCurrentIndex(currentIndex + 1)}
						>
							{showSkip ? t("skip", "Skip") : t("next", "Next")}
						</PrimaryButton>
					)}
				</Flex>
			</Segment>

			{(index < currentIndex || lastCheckMark) && (
				<Icon name="check" color="green" style={{ position: "absolute", right: 15, top: 15, fontSize: 18 }} />
			)}
		</div>
	);
}
